export default "__VITE_ASSET__DkOGFrNl__"